import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  IconButton,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@mui/material";
import { Add as AddIcon, Edit as EditIcon } from "@mui/icons-material";
import { db, auth } from "../../firebase-config";
import { collection, getDocs, addDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const ProjectList = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [budget, setBudget] = useState("");
  const [requirements, setRequirements] = useState("");
  const currentUser = auth.currentUser;
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) return;

    const fetchProjects = async () => {
      try {
        const projectsRef = collection(db, "projects");
        const snapshot = await getDocs(projectsRef);
        const projectsList = snapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((project) => project.createdBy === currentUser.uid);
        setProjects(projectsList);
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [currentUser]);

  const handleOpenDialog = () => {
    setTitle("");
    setDescription("");
    setBudget("");
    setRequirements("");
    setOpenDialog(true);
  };

  const handleSaveProject = async () => {
    if (!title ) return;

    try {
      const docRef = await addDoc(collection(db, "projects"), {
        title,
        //description,
        //budget: parseFloat(budget),
        //requirements: requirements.split(",").map((req) => req.trim()),
        createdBy: currentUser.uid,
        status: "draft",
      });

      setOpenDialog(false);

      // Navigate to the new project's view page
      navigate(`/projects/${docRef.id}`);
    } catch (error) {
      console.error("Error adding project:", error);
    }
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        My Projects
      </Typography>

      {/* New Project Button (Opens Popup) */}
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={handleOpenDialog}
        sx={{ mb: 2 }}
      >
        New Project
      </Button>

      {/* Loading Indicator */}
      {loading ? (
        <CircularProgress />
      ) : (
        <List>
          {projects.length > 0 ? (
            projects.map((project) => (
              <ListItem
                key={project.id}
                sx={{ display: "flex", justifyContent: "space-between", cursor: "pointer" }}
                onClick={() => navigate(`/projects/${project.id}`)}
              >
                <ListItemText
                  primary={project.title}
                  secondary={`Budget: $${project.budget} | Status: ${project.status}`}
                />
                <Box>
                  <IconButton onClick={() => navigate(`/projects/${project.id}`)} color="primary">
                    <EditIcon />
                  </IconButton>
                </Box>
              </ListItem>
            ))
          ) : (
            <Typography>No projects found.</Typography>
          )}
        </List>
      )}

      {/* Popup for Creating a New Project */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
        <DialogTitle>New Project</DialogTitle>
        <DialogContent>
          <TextField
            label="Title"
            fullWidth
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            sx={{ mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button onClick={handleSaveProject} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ProjectList;
